import SysUtils from '@/base/utils/SysUtils'

// ******************************************** //

// Config: Default Locale
const defaultLocale = 'zhHant'

// ******************************************** //

const currentLocale = SysUtils.getCookie('locale') ? SysUtils.getCookie('locale') : defaultLocale

document.cookie = 'locale=' + currentLocale

export default {
  currentLocale: currentLocale
}
